import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=1e5d3efc"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e5d3efc')) {
      api.createRecord('1e5d3efc', component.options)
    } else {
      api.reload('1e5d3efc', component.options)
    }
    module.hot.accept("./Tasks.vue?vue&type=template&id=1e5d3efc", function () {
      api.rerender('1e5d3efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/tasks/Tasks.vue"
export default component.exports